import { black } from '@styles/theme';
import { themeVars } from '@styles/themes.css';
import styled from 'styled-components';

export const TitleWrapper = styled.h2`
  font-family: ${themeVars.font.Magenos};
  font-size: 1.33rem !important;
  color: ${black} !important;
  font-weight: 900;
  word-wrap: break-word;
  line-height: 30px;
  margin: 0;
  width: 100%;
  padding: 0;

  @media (max-width: 480px) {
    font-size: 1.5rem !important;
    line-height: 1.2;
    letter-spacing: -0.5px;
  }
  @media (max-width: 390px) {
    margin: 10px 0 0;
  }
  @media (max-width: 350px) {
    width: 100%;
    margin: 10px 0 0;
  }
`;
